import { render, staticRenderFns } from "./informatization.vue?vue&type=template&id=d212a222&scoped=true&"
import script from "./informatization.vue?vue&type=script&lang=js&"
export * from "./informatization.vue?vue&type=script&lang=js&"
import style0 from "./informatization.vue?vue&type=style&index=0&id=d212a222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d212a222",
  null
  
)

export default component.exports